import { Dispatch, SetStateAction } from 'react';
import { SAVED_CONDITION_LIMIT } from 'constants/searchCondition';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { selectedCurrentConditionCount } from 'logics/selectedCurrentConditionCount';
import { DEFAULT_PARAMS } from '../../constants';
import {
  createConditionQueryObject,
  createQueryUrl,
  createUrl,
} from '../createSearchResultPageUrl';
import { ValidationErrorType } from '../../interface';

interface ArgumentType {
  selectedCurrentCondition: SelectedCurrentConditionType;
  isIncomeRangeError: boolean;
  setValidationError: Dispatch<SetStateAction<ValidationErrorType>>;
}

/**
 * 遷移先URLの生成処理を実行し遷移する
 * @param {object} param 遷移先URLの生成処理に必要な引数
 * @param {SelectedCurrentConditionType} param.selectedCurrentCondition 現在設定されている条件
 * @param {boolean} param.isIncomeRangeError 年収バリデーションのフラグ
 * @func setValidationError バリデーション判定用のセット関数
 */
export const moveToSearchResultPage = ({
  selectedCurrentCondition,
  isIncomeRangeError,
  setValidationError,
}: ArgumentType) => {
  const selectedTotalCount = selectedCurrentConditionCount(
    selectedCurrentCondition
  );
  // バリデーションチェック
  const isErrorConditionUpperLimit = selectedTotalCount > SAVED_CONDITION_LIMIT;
  setValidationError({
    isErrorNonCondition: false,
    isErrorConditionUpperLimit,
  });
  if (isErrorConditionUpperLimit) {
    window.scrollTo(0, 0);
    return;
  }
  // 希望年収エラーがあるか判定
  if (isIncomeRangeError) return;

  // 検索条件のクエリ文字列を生成
  const searchConditionQuery = createQueryUrl(
    createConditionQueryObject(selectedCurrentCondition, DEFAULT_PARAMS)
  );

  const url = createUrl(searchConditionQuery);

  window.location.href = url;
};
